import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    message: PropTypes.string,                                                  // success message
    showMessage: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])       // To show/hide the message
}
const SuccessBanner = ({ message, showMessage }) => {
    return (
        <>
            {showMessage &&
                <div className="link-success-msg">
                    <span className='icon-list-check' />
                    <span className="success-msg">{message}</span>
                </div>
            }
        </>
    );
}

SuccessBanner.propTypes = propTypes;

export default SuccessBanner;